import React from 'react'
import { Button } from 'spa/member/components/v2/Button'
import styles from './UserRegistrationButton.module.scss'

export const StyledUserRegistrationButton: React.FC = () => {
  return (
    <div className={`${styles.container}`}>
      <div
        className={`
          w-full flex flex-row flex-grow gap-2XS p-XS tablet:p-S tablet:gap-XS ${styles.buttonContainer}
        `}
      >
        <a href='/signup' className='w-full'>
          <Button buttonType='DEFAULT' kind='danger' link className={`w-full ${styles.button}`}>
            無料登録する
          </Button>
        </a>
        <a href='/login' className='w-full'>
          <Button buttonType='DEFAULT' kind='secondary' link className={`w-full ${styles.button}`}>
            ログインする
          </Button>
        </a>
      </div>
    </div>
  )
}
